import { Observable } from "rxjs";
import { ofType } from "redux-observable";

import { concatMap, map } from "rxjs/operators";
import { Actions } from "../../actions";
import { GetAssetStatusSuccess } from "../action-creators";
import { GET_ASSET_STATUS_SUCCESS } from "../actions";
import getAssetActions from "../utils/get-asset-actions";
import { NoOp } from "@webapp/store/ui/action-creators";
import { Action } from "redux";

export const validateAssetExists = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetAssetStatusSuccess>(GET_ASSET_STATUS_SUCCESS),
    map((action) => {
      const actions: Action[] = [];

      if (
        action.retryCounter >= 5 &&
        action.results.find((item) => !item.assetExists)
      ) {
        action.results.forEach((item) => {
          if (!item.assetExists) {
            actions.concat(getAssetActions(item.assetId));
          }
        });
        return actions;
      } else {
        actions.push(new NoOp());
      }
      return actions;
    }),
    concatMap((actions) => actions)
  );
